<template>
  <DeleteConfirmationModal
    :additionalText="additionalText"
    :bodyText="bodyText"
    cancelText="cancel"
    :confirmationInputConfig="confirmationInputConfig"
    continueText="delete"
    :handleCancel="hideModal"
    :handleContinue="action"
    :headerText="headerText"
    :mainActionAttention="true"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeDisplayNames, StoreModuleMap } from 'client/util/Constants';
import { extend } from 'lodash';
import { mapGetters } from 'vuex';
import DeleteConfirmationModal from 'components/Modal/ModalComponents/DeleteConfirmationModal.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import pluralize from 'pluralize';

const { system } = ItemTypeConsts;
const displayName = ItemTypeDisplayNames[system];

export default {
  name: 'SystemDeleteModal',

  components: {
    DeleteConfirmationModal,
  },

  props: {
    action: {
      required: true,
      type: Function,
    },
    itemType: {
      type: String,
      default: system,
    },
  },

  computed: {
    /**
     * @description Paragraph to follow main text and validation input
     */
    additionalText() {
      return this.fdeEnabledSystems.length
        ? `Deleting ${pluralize(displayName)} will also delete any saved Recovery Keys.`
        : '';
    },

    /**
     * @description Main body text for the dialog
     */
    bodyText() {
      let targetTypeName = displayName;
      let pronoun = 'this';
      let verb = 'is';

      if (this.selectedItems.length > 1) {
        targetTypeName = pluralize(displayName);
        pronoun = 'these';
        verb = 'are';
      }

      const bodyContent = `**${this.selectedItems.length}** ${targetTypeName} ${verb} selected for deletion.\n\n**Are you sure** you would like to delete ${pronoun} ${targetTypeName}? Deletion will uninstall the agent from any active ${pluralize(displayName)} and permanently remove all ${displayName} data and associations. This action may not be undone.`;

      return bodyContent;
    },

    /**
     * @description Configuration for validation input field
     */
    confirmationInputConfig() {
      const customErrorMessage = `Does not match the number of ${pluralize(displayName)} selected.`;
      const numItems = this.selectedItems.length;

      return {
        autofocus: true,
        confirmationText: `Please confirm the number of ${pluralize(displayName)} to be deleted.`,
        betweenCustomMessage: customErrorMessage,
        maxCustomMessage: customErrorMessage,
        minCustomMessage: customErrorMessage,
        name: `Delete ${pluralize(displayName)}`,
        numericCustomMessage: customErrorMessage,
        requiredCustomMessage: customErrorMessage,
        validationRule: `required|numeric|between:${numItems},${numItems}`,
      };
    },

    fdeEnabledSystems() {
      return this.getFdeType(this.selectedItems);
    },

    headerText() {
      return `Delete ${pluralize(displayName)}`;
    },
  },

  beforeCreate() {
    const itemType = this.$options.propsData.itemType ? this.$options.propsData.itemType : system;

    const storeModule = StoreModuleMap[itemType];

    if (!storeModule) {
      throw new Error('Could not find a storeModule to populate the item table.');
    }

    extend(
      this.$options.computed,
      mapGetters(storeModule, {
        getFdeType: 'getFdeType',
        selectedItems: 'getSelectedItems',
      }),
    );
  },

  methods: {
    hideModal() {
      ModalEventBus.close();
    },
  },
};
</script>
